export default {
  categories: [],
  integrationBySlug: {},
  catalogLoading: false,
  catalogError: null,
}
